import Track from "../Track/Track";
import "./CupDisplay.css";

/**
 * Unified component for displaying a collection of tracks in a cup.
 * Handles three main use cases:
 * 1. Browse mode - static display of completed cups
 * 2. Track selection mode - interactive track picker
 * 3. Your cup mode - shows user's in-progress cup with selection state
 * 
 * @param {Object} props
 * @param {Array} props.tracks - Array of track objects to display
 * @param {string} props.variant - Display variant: 'browse' | 'selection' | 'your-cup'
 * @param {function} props.onTrackClick - Callback when track is clicked (selection mode)
 * @param {number} props.selectedIndex - Index of currently selected track (your-cup mode)
 * @param {boolean} props.showEmblems - Whether to show cup emblems on tracks
 */
export default function CupDisplay({
    tracks,
    variant = 'browse',
    onTrackClick,
    selectedIndex = -1,
    showEmblems = false
}) {
    
    // Determine CSS class based on variant
    const containerClass = `cup-display cup-display--${variant}`;
    
    // Determine if tracks are clickable
    const isInteractive = variant === 'selection';
    
    // Determine if track should show selected state
    const isSelected = (index) => variant === 'your-cup' && selectedIndex === index;
    
    return (
        <div className="cup-display-container">
            <div className="cup-outline">
                <ul className={`${containerClass}`}>
                    {tracks?.map((track, index) => (
                        <li key={index} className="trackparent">
                            <Track
                                key={index}
                                index={index}
                                track={track}
                                // size={"small"}
                                showCursor={isInteractive}
                                tabIndex={isInteractive ? 0 : -1}
                                addToCup={onTrackClick}
                                yourCup={variant === 'your-cup'}
                                selectTrack={variant === 'your-cup' ? selectedIndex : (isInteractive ? 1 : 5)}
                                select={isSelected(index)}
                                showEmblem={showEmblems}
                            />
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
